#import "../fragments/sms-edition-engagement-stats-fragment.graphql"

query GetSmsEditionEngagementStats($editionId: ID!) {
    smsEdition(id: $editionId) {
        id
        status
        engagementStats {
            ...SmsEditionEngagementStatsFragment
        }
    }
}
